import { __module as e } from "../../../_virtual/escape.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(a = e.exports, "__esModule", {
  value: !0
}), a.default = function (e) {
  return (0, t.default)(e), e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
}, t = r && r.__esModule ? r : {
  default: r
}, e.exports = a.default, e.exports.default = a.default;
var a,
  t,
  l = e.exports;
export { l as _ };